import {
  getAccountInfoARMock,
  getAccountInfoMock,
  updateAliasResponseMock,
} from 'mocks/accountInfo'

import {
  IHttpOptions,
  IHttpOptionsWithBody,
  IWbHttpData,
  interWbHttp as nativeInterWbHttp,
} from '@interco/inter-webview-bridge'

const MOCK_DELAY_MS = 400

const delay = async () => {
  await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY_MS))
}

const toWbHttpData = (data: unknown): IWbHttpData => ({
  headers: {},
  httpStatus: 200,
  response: JSON.stringify(data),
  timeSpent: MOCK_DELAY_MS,
})

const resolveGetData = (endpoint: string): unknown => {
  if (endpoint.includes('/screens/dados-bancarios')) {
    return endpoint.includes('type=') ? getAccountInfoARMock : getAccountInfoMock
  }

  throw new Error(`[mock] GET sem handler para endpoint: ${endpoint}`)
}

const resolvePostData = (endpoint: string): unknown => {
  if (endpoint.includes('/alias/configuration')) {
    return updateAliasResponseMock
  }

  throw new Error(`[mock] POST sem handler para endpoint: ${endpoint}`)
}

const mockInterWbHttp: typeof nativeInterWbHttp = {
  get: async ({ endpoint }: IHttpOptions) => {
    await delay()
    return toWbHttpData(resolveGetData(endpoint))
  },
  post: async ({ endpoint }: IHttpOptionsWithBody) => {
    await delay()
    return toWbHttpData(resolvePostData(endpoint))
  },
  put: async ({ endpoint }: IHttpOptionsWithBody) => {
    await delay()
    return toWbHttpData(resolvePostData(endpoint))
  },
  delete: async ({ endpoint }: IHttpOptions) => {
    await delay()
    return toWbHttpData(resolveGetData(endpoint))
  },
}

export const interWbHttp =
  (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') &&
  process.env.REACT_APP_MOCK_ENABLED === 'true'
    ? mockInterWbHttp
    : nativeInterWbHttp
